import { ITraderWallet } from '@entities/trades/wallet';
import { MultiStepForm } from '@features/multi-step-form';

import { StepConfirm } from './StepConfirm';
import { StepCreate } from './StepCreate';

interface IProps<T> {
  wallet: T;
  refetch: () => void;
}

export const CreateTokenSale = <T extends ITraderWallet>({ wallet, refetch }: IProps<T>) => {
  return (
    <MultiStepForm
      steps={[
        { title: 'Create', content: <StepCreate wallet={wallet} /> },
        { title: 'Confirm', content: <StepConfirm wallet={wallet} refetch={refetch} /> },
      ]}
    />
  );
};
